export const boardingFiltersInitialValues = {
	ageMaximum: "",
	ageMinimum: "",
	ageMaxDay: "",
	ageMaxHours: "",
	ageMaxMinutes: "",
	ageMinDay: "",
	ageMinHours: "",
	ageMinMinutes: "",
	agent_name: "",
	agent_office: "",
	number: "",
	assignedTo: "",
	completeStatus: "",
	ageOfPendFrom: "",
	ageOfPendTo: "",
	merchant_name: "",
	mid: "",
	pendedTo: "",
	pendReason: "",
	pendStatus: "",
	processor: "",
	sponsor: "",
};
